var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
        'lang-rtl': _vm.$i18n.locale === 'he'
    }},[_c('app-header'),_vm._v(" "),_c('div',{staticClass:"app-content content main-content-wrapper"},[_c('tabs'),_vm._v(" "),_c('nuxt')],1),_vm._v(" "),_c('div',{staticClass:"sidenav-overlay"}),_vm._v(" "),_c('div',{staticClass:"drag-target"}),_vm._v(" "),_c('portal-target',{attrs:{"name":"modal","multiple":""}}),_vm._v(" "),_c('info-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }